import {ServicePathFieldGroup, ServicePathResponse} from '../types/servicePath.types';
import {WorkStagesDataWithDeviceTypeCode} from '../types/form.types';
import {getModelName} from '../helpers/modelName';

export const mapServicePathResponseToSteps = (
  response: ServicePathResponse,
  deviceTypeCode: string,
): WorkStagesDataWithDeviceTypeCode => {
  if (!response || Object.keys(response).length === 0) return {steps: [], deviceTypeCode};
  
  const steps = Object.entries(response).map(([index, fields]) => {
    const arrFields = Array.isArray(fields) ? fields : [];
    const stage = arrFields[0]?.stage;
    const stageId = arrFields[0]?.stageId;
    return {
      id: String(stageId),
      title: stage?.name || `Шаг ${index}`,
      description: stage?.description ?? '',
      isRequired: false,
      saveOnComplete: stage.needToPreSave,
      editModeOnly: false,
      fieldGroups: arrFields.map((field: ServicePathFieldGroup) => ({
        id: String(field.id),
        title: field.name,
        defaultValue: field.defaultValue ?? '',
        dataType: field.inputType,
        fileCount: field.maxFilesAllowed ?? 0,
        isRequired: !!field.mandatory,
        editableAfterSubmit: !!field.editable,
        editModeOnly: !!field.forRevisionOnly,
        forWebOnly: !!field.forWebOnly,
        modelName: getModelName(field.name, field.modelName),
      })),
    };
  });
  return {steps, deviceTypeCode};
};
